'use client'

import React, { useEffect } from "react";
import { CurrentSnackbarData, EventTypes } from "@/types/types";
import { Emitter } from "@/services/event-emitter";
import { SnackbarEventTypes } from "@/enum/snackbarEventTypes.ts";
import UserEventPlayingTrackSnackbar from "@/features/Snackbar/UserEventPlayingTrackSnackbar.tsx";
import UserEventSharedTrackSnackbar from "@/features/Snackbar/UserEventSharedTrackSnackbar.tsx";
import UserEventSharedSegmentSnackbar from "@/features/Snackbar/UserEventSharedSegmentSnackbar.tsx";
import PointUserConnectionMentionSnackbar from "@/features/Snackbar/PointUserConnectionMentionSnackbar";
import useCurrentSnackbar from "@/common/hooks/useCurrentSnackbar.ts";
import SegmentUserConnectionMentionSnackbar from "@/features/Snackbar/SegmentUserConnectionMentionSnackbar.tsx";
import { GenericSnackbar } from "@/common/components/Snackbar/GenericSnackbar.tsx";

export default function UserEventSnackbarProvider(): React.ReactNode {
  const [currentSnackbar, setCurrentSnackbar] = useCurrentSnackbar()

  const handleOnClose = () => {
    setCurrentSnackbar(null)
  }

  useEffect(() => {
    const handleUserEventShowSnackbar = (snackbarData: CurrentSnackbarData) => {
      setCurrentSnackbar(snackbarData)
    }

    Emitter.on(EventTypes.USER_EVENT_SHOW_SNACKBAR, handleUserEventShowSnackbar)

    return () => {
      Emitter.off(EventTypes.USER_EVENT_SHOW_SNACKBAR, handleUserEventShowSnackbar)
      setCurrentSnackbar(null)
    }
  }, [setCurrentSnackbar])

  if (!currentSnackbar) {
    return <GenericSnackbar />
  }

  return <>
    {currentSnackbar?.type === SnackbarEventTypes.USER_EVENT_PLAYING_TRACK &&
      <UserEventPlayingTrackSnackbar snackbar={currentSnackbar} onClose={handleOnClose} />}

    {currentSnackbar?.type === SnackbarEventTypes.USER_EVENT_SHARED_TRACK &&
      <UserEventSharedTrackSnackbar snackbar={currentSnackbar} onClose={handleOnClose} />}

    {currentSnackbar?.type === SnackbarEventTypes.USER_EVENT_SHARED_SEGMENT &&
      <UserEventSharedSegmentSnackbar snackbar={currentSnackbar} onClose={handleOnClose} />}

    {currentSnackbar?.type === SnackbarEventTypes.POINT_CONVERSATION_USER_MENTIONED &&
      <PointUserConnectionMentionSnackbar snackbar={currentSnackbar} onClose={handleOnClose} />}

    {currentSnackbar?.type === SnackbarEventTypes.SEGMENT_CONVERSATION_USER_MENTIONED &&
      <SegmentUserConnectionMentionSnackbar snackbar={currentSnackbar} onClose={handleOnClose} />}

    <GenericSnackbar />
  </>
}
